import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./datepicker.css";
import Routes from "./Routes";
import * as serviceWorker from "./serviceWorker";
import { Router } from "react-router-dom";
import history from "./config/history";
import { StyledEngineProvider } from "@mui/material";

const container = document.getElementById("root");

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <Router history={history}>
        <Routes />
      </Router>
    </StyledEngineProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
